import { render, staticRenderFns } from "./Promo.vue?vue&type=template&id=179f9faa&scoped=true&"
import script from "./Promo.vue?vue&type=script&lang=js&"
export * from "./Promo.vue?vue&type=script&lang=js&"
import style0 from "./Promo.vue?vue&type=style&index=0&id=179f9faa&scoped=true&lang=scss&"
import style1 from "./Promo.vue?vue&type=style&index=1&id=179f9faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "179f9faa",
  null
  
)

export default component.exports